<div class="accordion mb-3" [attr.id]="accordionId">
    <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" [class.is-down]="isDown" type="button" data-bs-toggle="collapse"
        [attr.data-bs-target]="'#collapseOne' + accordionId" aria-expanded="false" [attr.aria-controls]="'collapseOne' + accordionId">
        {{accordionTitle}}
      </button>
    </h2>
    <div [attr.id]="'collapseOne' + accordionId" class="accordion-collapse collapse" [attr.data-bs-parent]="'#' + accordionId">
      <div class="accordion-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
